import { FormEvent } from 'react';
import { ButtonGroup, Well, FormControl } from 'react-bootstrap';
import { ICenterBase } from '@nkr/models/index';
import { useAppHookContext } from '@nkr/utils/rest-api';
import { OrganType } from '@nkr/enums/organ-type';

interface IProps {
    startDate: string,
    endDate: string,
    isAdmin: boolean,
    centerId: number,
    includeDash: boolean,
    includeNkr: boolean,
    includeUdash: boolean,
    includeMs: boolean,
    centerList: ICenterBase[],
    onChange: (property: string) => void,
    onFilterChange: (startDate: string, endDate: string, centerId: number,) => void,
    onFilter: () => void
}

const Filter = (props: IProps) => {
    const { app: { site } } = useAppHookContext();

    const handleIncludeChange = (e: React.FormEvent<HTMLButtonElement>) => {
        props.onChange(e.currentTarget.value);
    };

    const handleStartDateChange = (e: FormEvent<FormControl & HTMLInputElement>) => {
        let startDate = e.currentTarget.value;
        props.onFilterChange(startDate, props.endDate, props.centerId);
    };

    const handleEndDateChange = (e: FormEvent<FormControl & HTMLInputElement>) => {
        let endDate = e.currentTarget.value;
        props.onFilterChange(props.startDate, endDate, props.centerId);
    };

    const handleCenterChange = (e: React.ChangeEvent<FormControl & HTMLSelectElement>) => {
        let centerId = parseInt(e.currentTarget.value);
        props.onFilterChange(props.startDate, props.endDate, centerId);
    }

    return (
        <Well bsSize='sm'>
            <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'nowrap', gap: 12 }}>
                {props.isAdmin &&
                    <div style={{ display: 'flex', alignItems: 'center', flexShrink: 0 }}>
                        <div style={{ marginRight: 5 }}>Center:&nbsp;</div>
                        <FormControl
                            componentClass='select'
                            style={{ width: 'initial' }}
                            value={props.centerId}
                            onChange={handleCenterChange}
                        >
                            <option value={0}>- ALL CENTERS -</option>
                            {props.centerList.map((center, index) =>
                                <option key={index} value={center.id}>{center.alias}</option>
                            )}
                        </FormControl>
                    </div>
                }

                <div style={{ flexShrink: 0 }}>
                    <ButtonGroup>
                        <button type='button' className={'btn ' + (props.includeDash ? 'btn-primary active' : 'btn-default')} value='includeDash' onClick={handleIncludeChange}>{props.isAdmin ? 'PL DASH' : 'DASH'}</button>
                        {props.isAdmin && <button type='button' className={'btn ' + (props.includeUdash ? 'btn-primary active' : 'btn-default')} value='includeUdash' onClick={handleIncludeChange}>UDASH</button>}
                        {props.isAdmin && <button type='button' className={'btn ' + (props.includeMs ? 'btn-primary active' : 'btn-default')} value='includeMs' onClick={handleIncludeChange}>MSDASH</button>}
                        <button type='button' className={'btn ' + (props.includeNkr ? 'btn-primary active' : 'btn-default')} value='includeNkr' onClick={handleIncludeChange}>{props.isAdmin ? 'NKR Websites' : (site.organType == OrganType.Kidney ? 'NKR' : 'NLR')}</button>
                    </ButtonGroup>
                </div>

                <div style={{ display: 'flex', alignItems: 'center', flex: 1 }}>
                    <div style={{ display: 'flex', alignItems: 'center', marginRight: 20 }}>
                        <div style={{ marginRight: 5 }}>Registered between:&nbsp;</div>
                        <FormControl
                            type='date'
                            name='startDate'
                            style={{ width: 'initial' }}
                            value={props.startDate}
                            onChange={handleStartDateChange}
                        />
                    </div>

                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <div style={{ marginRight: 5 }}>and&nbsp;</div>
                        <FormControl
                            type='date'
                            name='endDate'
                            style={{ width: 'initial' }}
                            value={props.endDate}
                            onChange={handleEndDateChange}
                        />
                    </div>

                    <div style={{ flexShrink: 0, marginLeft: 20 }}>
                        <button type='button' className='btn btn-primary' onClick={props.onFilter}>Filter</button>
                    </div>
                </div>
            </div>
        </Well>
    );
}

export default Filter;
